module.exports = __webpack_public_path__ + "static/img/capartdela.f4d7000.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/capartdela.png
// module id = 29
// module chunks = 0